import React, { useRef, useEffect, useState } from 'react';
import ResultsSummary from './ResultsSummary.jsx';
import DonutChart from './DonutChart.jsx';
import BarChart from './BarChart.jsx';
import DetailedTable from './DetailedTable.jsx';
import BenefitTable from './BenefitTable.jsx';
import ExportPdfButton from './ExportPdfButton.jsx';
import { BENEFIT_VALUE_PROPOSITIONS } from '../libs/types.js';
import ExportPowerPointButton from './ExportPowerPointButton.jsx';

const ResultsDisplay = ({ calculationResults, logErrorMessage, logSuccessMessage }) => {
    const donutChartCanvasRef = useRef();
    const barChartCanvasRef = useRef();
    const [chartsReadyForExport, setChartsReadyForExport] = useState(false);


    // Effect to update chartsReadyForExport when refs become available
    useEffect(() => {
        const checkReady = () => {
            if (calculationResults && donutChartCanvasRef.current && barChartCanvasRef.current) {
                setChartsReadyForExport(true);
            } else {
                setChartsReadyForExport(false);
            }
        };
        checkReady();
        // Listen for ref changes
        const interval = setInterval(checkReady, 100);
        return () => clearInterval(interval);
    }, [calculationResults]);

    useEffect(() => {
        if (chartsReadyForExport) {
            console.log('ResultsDisplay: Chart canvases are ready for export!');
            console.log('Donut Canvas:', donutChartCanvasRef.current);
            console.log('Bar Canvas:', barChartCanvasRef.current);
        }
    }, [chartsReadyForExport]);

    if (!calculationResults) return null;

    return (
        <>
            <div className="mt-12 space-y-8">
                <hr className="my-8 border-t border-gray-300" />
                <h2 className="text-xl font-semibold text-gray-800 text-center">
                    Benefits Value Analysis
                </h2>
                {/*
        {logSuccessMessage && (
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-4" role="alert">
            <span className="block sm:inline">{logSuccessMessage}</span>
            </div>
        )}
        */}
                {logErrorMessage && (
                    <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
                        <span className="block sm:inline">{logErrorMessage}</span>
                    </div>
                )}
                <ResultsSummary results={calculationResults} />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
                    <div className="min-h-96 h-64 md:h-96">
                        <DonutChart results={calculationResults} canvasRef={donutChartCanvasRef} />
                    </div>
                    <div className="min-h-96 h-64 md:h-96">
                        <BarChart results={calculationResults} canvasRef={barChartCanvasRef} />
                    </div>
                </div>
                <BenefitTable results={calculationResults} />
                <DetailedTable results={calculationResults} />
                <div className="text-center mt-8 flex flex-col sm:flex-row justify-center gap-4">
                    <ExportPowerPointButton
                        results={calculationResults}
                        donutCanvasElement={donutChartCanvasRef.current}
                        barCanvasElement={barChartCanvasRef.current}
                    />
                    <ExportPdfButton
                        results={calculationResults}
                        donutCanvasElement={chartsReadyForExport ? donutChartCanvasRef.current : null}
                        barCanvasElement={chartsReadyForExport ? barChartCanvasRef.current : null}
                        BENEFIT_VALUE_PROPOSITIONS={BENEFIT_VALUE_PROPOSITIONS}
                    />
                </div>
            </div>
        </>
    );
};

export default ResultsDisplay;
